/**
 * The review banner remembers, on the device only, whether this person has
 * already answered it or dismissed it. There is no backend for this: a new
 * phone or a reinstall starts over, which is an accepted trade-off.
 */
const ANSWERED_KEY = 'optiwatt.reviewBanner.answeredAt'
const DISMISSED_KEY = 'optiwatt.reviewBanner.dismissedAt'

function readStoredDate(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    // Storage can throw in private mode or when site data is blocked
    return null
  }
}

function writeStoredDate(key: string, value: string) {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    // Nothing to do: the banner just shows again next time
  }
}

export function getAnsweredAt() {
  return readStoredDate(ANSWERED_KEY)
}

export function getDismissedAt() {
  return readStoredDate(DISMISSED_KEY)
}

export function markAnswered(now: Date = new Date()) {
  writeStoredDate(ANSWERED_KEY, now.toISOString())
}

export function markDismissed(now: Date = new Date()) {
  writeStoredDate(DISMISSED_KEY, now.toISOString())
}
